import React from 'react';
import { TagIcon, CoinsIcon, GiftIcon, MailIcon, StarIcon } from 'lucide-react';
export function CustomerCareClub() {
  const benefits = [{
    title: '$10 Off Premium Pet Food',
    description: 'Save $10 on every big bag of premium pet food over 11kg.',
    icon: TagIcon
  }, {
    title: 'Earn Reward Points',
    description: 'Earn points on every purchase. They never expire.',
    icon: CoinsIcon
  }, {
    title: '$10 Reward at 200 Points',
    description: 'Reach 200 points and get $10 off your next purchase.',
    icon: GiftIcon
  }, {
    title: 'Members-Only Specials',
    description: 'Monthly newsletter with tips, advice & exclusive offers.',
    icon: MailIcon
  }];
  return <section className="section-padding bg-warm-50 border-y border-warm-200" data-id="element-10">
      <div className="container-wide" data-id="element-11">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-12">
          {/* Content Side */}
          <div className="lg:col-span-7 lg:pr-10" data-id="element-13">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-blue-100 text-brand-blue mb-6 shadow-sm" data-id="element-14">
              <GiftIcon className="w-8 h-8" data-id="element-15" />
            </div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-blue-50 text-brand-blue text-sm font-bold mb-4" data-id="element-16">
              <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-17"></span>
              15,000+ members already saving
            </div>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-gray-900 mb-4 leading-tight" data-id="element-18">
              Join the{' '}
              <span className="text-brand-blue" data-id="element-19">Customer Care Club</span>
            </h2>
            <p className="text-xl text-gray-600 mb-10 max-w-2xl" data-id="element-20">
              Free to join. Real rewards. Better value on every visit. No
              physical card needed — just use your phone number at checkout.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10" data-id="element-21">
              {benefits.map((benefit, index) => <div key={index} className="flex gap-4" data-id="element-22">
                  <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center flex-shrink-0 border border-gray-100" data-id="element-23">
                    <benefit.icon className="w-5 h-5 text-brand-blue" data-id="element-24" />
                  </div>
                  <div data-id="element-25">
                    <h3 className="font-heading font-bold text-gray-900 mb-1" data-id="element-26">
                      {benefit.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed" data-id="element-27">
                      {benefit.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-28">
              <button className="btn-primary py-4 px-8 text-lg shadow-blue-glow" data-id="element-29">
                Join Free Today
              </button>
              <button className="btn-secondary bg-white py-4 px-8 text-lg" data-id="element-30">
                Log In to Account
              </button>
            </div>
          </div>

          {/* Image Side */}
          <div className="lg:col-span-5 relative" data-id="element-31">
            <div className="relative rounded-[2.5rem] overflow-hidden aspect-[4/5] shadow-elevated" data-id="element-32">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=800&q=80')] bg-cover bg-center" data-id="element-33"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-brand-blue-900/80 via-transparent to-transparent" data-id="element-34"></div>

              <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-35">
                <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 text-white" data-id="element-36">
                  <div className="flex items-center gap-2 mb-2" data-id="element-37">
                    <StarIcon className="w-5 h-5 text-yellow-400 fill-current" data-id="element-38" />
                    <span className="font-bold" data-id="element-39">Member Since 2021</span>
                  </div>
                  <p className="text-brand-blue-50 italic" data-id="element-40">
                    "I save so much on my dog's premium food, and the points add
                    up faster than you think!"
                  </p>
                </div>
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-brand-green-100 rounded-full mix-blend-multiply filter blur-2xl opacity-70 -z-10" data-id="element-41"></div>
            <div className="absolute -bottom-10 -left-10 w-48 h-48 bg-brand-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 -z-10" data-id="element-42"></div>
          </div>
        </div>
      </div>
    </section>;
}